import React, { Component, createRef } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { connect } from "react-redux";
import { Toast } from "primereact/toast";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import axios from "axios";
import { Button } from "primereact/button";
import { ConfirmPopup } from "primereact/confirmpopup";
import { setUserSessionAuthKey } from "../../Component/commonUtils";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import NavBarHeader from "../NavBarHeader/NavBarHeader";
import FooterContactTab from "../Footerpage/Footer_contact_tab";
import config from "../../Configuration/Config";
import { Checkbox } from "primereact/checkbox";
import { Fieldset } from "primereact/fieldset";
import "./ReviewAndSend.css";
import { setupLocales } from "../../Component/setupLocales";
import Joyride from "react-joyride";
import { previewPdfOnSamePage } from "../../Component/commonUtils";
import { ProgressBar } from "primereact/progressbar";
import { Dialog } from "primereact/dialog";
import SentToBolagsverketGif from "../../Assests/SentToBolagsverket.gif";
import { CopyToClipboard } from "react-copy-to-clipboard";
import moment from "moment";
import { ConfirmDialog } from "primereact/confirmdialog";
import NoAccess from "../../Component/NoAccess/NoAccess";
import { Carousel } from "primereact/carousel";
import BolagsverketImage1 from "../../Assests/userGuide1.png";
import BolagsverketImage2 from "../../Assests/userGuide2.png";
import RBBLiframe from "../../Component/ReviewPage/iframe/RBBLiframe";

import { ProgressSpinner } from "primereact/progressspinner";

let userSessionAuthKeyReturnValue = setUserSessionAuthKey();
let tourGuidePages = localStorage.getItem("tourGuidePages");
let currentPageTourGuideName = "ReviewAndSend";

const mapStateToProps = (state) => {
  return {
    annualReportType: state.annualReportType.annualReportType.values,
    companyInformation: state.companyInformation.companyInformation.values,
    financialYear: state.financialYear.financialYear,
    sessionDetails: state.sessionDetails.sessionDetails.values,
    login: state.login.login.values,
    sideBarReducer: state.sideBarReducer.sideBarReducer,
    prices: state.prices.prices,
    currentPageName: state.currentPageName.currentPageName,
    payment: state.payment.payment
  };
};
let currentReportGUIDFromUrl = "",
  linkSharedUser,
  sideBarGreenTickPages = [];
let userSelectedLanguage,
  localeLang = "";
let selectedSSNResult;
let steps = [];

const Carouselitems = [
  {
    src: SentToBolagsverketGif,
    zoom: false
  },
  {
    src: BolagsverketImage1,
    zoom: false
  },
  {
    src: BolagsverketImage2,
    zoom: true
  },
  {
    src: SentToBolagsverketGif,
    zoom: false
  }
];

class ReviewAndSend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkoutId: "",
      checkoutPurchaseId: "",
      checkoutAmount: 0,
      showPayementSuccessModal: false,
      showNotification: false,
      pdfUrl: "",
      sideBarStatus: true,
      isLoading: true,
      getRepList: "",
      repOptions: [],
      repValue: "",
      repSSN: "",
      repEmailId: "",
      repDate: new Date(),
      termsCheck: false,
      run: false,
      firstName: "",
      lastName: "",
      designation: "",
      ssn: null,
      emailId: "",
      ssnOptions: [],
      headerResponse: "",
      bolagsverketApiBtnClicked: false,
      bolagsverketApiLoading: "",
      bolagsverketApiResponse: "",
      bolagsverketApiStatus: false,
      bolagsverketSubmitLimitReachedDialog: false,
      paymentPending: false,
      showAlert: false,
      sentToBolagsverketDialogBox: false,
      sentToBolagsverketCarouselPage: 0,
      goToBolagsverketLink: "",
      goToMyDashboardLink: "",
      sentToBolagsverketCount: 0,
      showConfirmReSubmitDialogBox: false,
      confirmReSubmitBtn: false,
      showSkatterverketButton: false,
      accessLevel: 0,
      loading: false,
      loadingDialog: false,
      infoDialog: false,
      infoMessage: "",
      verifyAPIWarning: ""
    };
    this.acceptSendToBolagsverket = this.acceptSendToBolagsverket.bind(this);
    this.msgs = createRef();
    this.toast = createRef();
    this.progressInterval = null;
    this.carouselInterval = null;
    this.carouselStopTimeout = null;
    this.timer = null; // store timeout/interval reference
  }

  startSentToBolagsverketCarousel = () => {
    this.stopSentToBolagsverketCarousel();
    this.carouselInterval = setInterval(() => {
      this.setState((prevState) => ({
        sentToBolagsverketCarouselPage:
          (prevState.sentToBolagsverketCarouselPage + 1) % Carouselitems.length
      }));
    }, 2000);

    this.carouselStopTimeout = setTimeout(() => {
      this.stopSentToBolagsverketCarousel(true);
    }, 16000);
  };

  stopSentToBolagsverketCarousel = (resetToFirst = false) => {
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
      this.carouselInterval = null;
    }

    if (this.carouselStopTimeout) {
      clearTimeout(this.carouselStopTimeout);
      this.carouselStopTimeout = null;
    }

    if (resetToFirst) {
      this.setState({ sentToBolagsverketCarouselPage: 0 });
    }
  };

  getAnnualReportSetup = async () => {
    try {
      const rebelSkoolUser = JSON.parse(localStorage.getItem("rebelSkoolUser"));

      const authKey = rebelSkoolUser?.["User-Session-Auth-Key"];

      if (!authKey) {
        return false;
      }

      const apiDomain = localStorage.getItem("apiDomain")?.replace(/\/$/, "");

      const { data } = await axios.get(
        `${apiDomain}/annualReportRepresentative/getSkatteverketUIConfig`,
        {
          headers: {
            "User-Session-Auth-Key": authKey
          }
        }
      );

      const environmentMap = {
        TEST: "testEnvironment",
        LOCAL: "localEnvironment",
        LIVE: "liveEnvironment"
      };

      const environment = environmentMap[(data?.mode || "").toUpperCase()];

      return data?.[environment]?.isShowSkatterverketButtonVisible ?? false;
    } catch (error) {
      console.error("Error:", error?.message || error);
      return false;
    }
  };

  extractUUIDFromAnnualReportURL = () => {
    const path = window.location.pathname;

    const match = path.match(
      /^\/annualreport\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\/reviewAndSend\/?$/
    );

    if (!match) {
      throw new Error(
        "Invalid URL format. Expected /annualreport/{UUID}/reviewAndSend"
      );
    }

    return match[1];
  };

  goToSRUPortal = async () => {
    // Prevent duplicate clicks
    if (this.state.loading) return;

    try {
      /*
      =====================================================
      STEP 1: START PROCESSING
      =====================================================
      */

      this.setState({
        loading: true,
        processingDialog: true,
        processingMessage: "Validating access..."
      });

      /*
      =====================================================
      STEP 2: USER AUTH
      =====================================================
      */

      const rebelSkoolUser = JSON.parse(localStorage.getItem("rebelSkoolUser"));

      const authKey = rebelSkoolUser?.["User-Session-Auth-Key"];

      if (!authKey) {
        throw new Error("Missing auth key in localStorage");
      }

      // const reportGUID = localStorage.getItem("sessionUUID"); -- Prevent GUID Collision

      /*
      =====================================================
      STEP 3: REPORT GUID
      =====================================================
      */

      const reportGUID = this.extractUUIDFromAnnualReportURL();

      if (!reportGUID || reportGUID.trim() === "") {
        throw new Error("Annual Report GUID is Missing");
      }

      /*
      =====================================================
      STEP 4: API DOMAIN
      =====================================================
      */

      const apiDomain = localStorage.getItem("apiDomain")?.replace(/\/$/, "");

      if (!apiDomain) {
        throw new Error("Missing API domain");
      }

      /*
      =====================================================
      STEP 5: ACCESS VALIDATION
      =====================================================
      */

      const accessResponse = await fetch(
        `${apiDomain}/annualReport/getAccessStatusByReportGUID`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "User-Session-Auth-Key": authKey
          },
          body: JSON.stringify({
            reportGUID: reportGUID
          })
        }
      );

      const accessResult = await accessResponse.text();

      if (!accessResponse.ok) {
        throw new Error(accessResult || "Access validation failed");
      }

      const normalizedAccessResult = accessResult?.trim();

      if (
        !normalizedAccessResult ||
        normalizedAccessResult === "0" ||
        normalizedAccessResult === "4"
      ) {
        throw new Error("Unauthorized access or report unavailable");
      }

      /*
      =====================================================
      STEP 6: MESSAGE - CHECKING SIE FILE
      =====================================================
      */

      this.setState({
        processingMessage: "Checking SIE File..."
      });

      /*
      =====================================================
      STEP 7: GENERATE SRU GUID
      =====================================================
      */

      console.log("Before generateUUID");
      const uuidResponse = await fetch(`${apiDomain}/cms/generateUUID`, {
        method: "GET",
        headers: {
          "User-Session-Auth-Key": authKey
        }
      });

      let sruReportGUID = await uuidResponse.text();

      sruReportGUID = sruReportGUID.trim().replace(/^"|"$/g, "");

      if (!sruReportGUID) {
        throw new Error("Failed to generate SRU Report GUID");
      }

      const uuidRegex =
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

      if (!uuidRegex.test(sruReportGUID)) {
        throw new Error("Invalid SRU GUID format received");
      }

      console.log("Generated SRU GUID:", sruReportGUID);

      /*
      =====================================================
      STEP 8: MIGRATION API
      =====================================================
      */

      this.setState({
        processingMessage: "Preparing Income Declaration..."
      });

      const migrateResponse = await fetch(
        `${apiDomain}/SRUHeader/migrateARHeaderSIEtoSRU?annualReportGUID=${reportGUID}&sruReportGUID=${sruReportGUID}`,
        {
          method: "POST",
          headers: {
            "User-Session-Auth-Key": authKey
          }
        }
      );

      let migrateResult = null;

      try {
        migrateResult = await migrateResponse.json();
      } catch (e) {
        throw new Error("Invalid response from migration API");
      }

      console.log("Migrate Result:", migrateResult);

      /*
      =====================================================
      STEP 9: SIE EMPTY HANDLING
      =====================================================
      */

      if (
        migrateResult?.error === "Annual Report Header SIE File is Empty/NULL"
      ) {
        this.setState({
          processingMessage:
            "No SIE File uploaded. Make Fresh Report to Income Declaration..."
        });

        await new Promise((r) => setTimeout(r, 1200));

        this.setState({
          processingMessage: "Redirecting to Income Declaration..."
        });

        setTimeout(() => {
          this.setState({
            processingDialog: false
          });

          window.open(
            `/income-declaration-2/${sruReportGUID}/companyInfo`,
            "_blank"
          );
        }, 1000);

        return;
      }

      /*
      =====================================================
      STEP 10: MIGRATION ERROR HANDLING
      =====================================================
      */

      if (!migrateResponse.ok || migrateResult?.status === false) {
        throw new Error(migrateResult?.error || "Migration failed");
      }

      /*
      =====================================================
      STEP 11: FINAL GUID
      =====================================================
      */

      const finalSruGUID = migrateResult?.data || sruReportGUID;

      if (!finalSruGUID) {
        throw new Error("SRU GUID not returned");
      }

      /*
      =====================================================
      STEP 12: SUCCESS MESSAGE FLOW
      =====================================================
      */

      this.setState({
        processingMessage:
          "The Income Declaration is prepared based on your uploaded SIE File."
      });

      await new Promise((r) => setTimeout(r, 1200));

      this.setState({
        processingMessage: "Income Declaration prepared successfully."
      });

      await new Promise((r) => setTimeout(r, 1200));

      this.setState({
        processingMessage: "Redirecting to Income Declaration..."
      });

      /*
      =====================================================
      STEP 13: REDIRECT
      =====================================================
      */

      setTimeout(() => {
        this.setState({
          processingDialog: false
        });

        window.open(
          `/income-declaration-2/${finalSruGUID}/companyInfo`,
          "_blank"
        );
      }, 1200);
    } catch (error) {
      /*
      =====================================================
      ERROR HANDLING
      =====================================================
      */

      console.error("goToSRUPortal error:", error);

      this.setState({
        processingDialog: false
      });

      const errorMessage =
        error?.message || "Something went wrong. Please try again.";

      if (this.toast?.show) {
        this.toast.show({
          severity: "error",
          summary: "Error",
          detail: errorMessage,
          life: 5000
        });
      } else {
        alert(errorMessage);
      }
    } finally {
      /*
      =====================================================
      RESET LOADING
      =====================================================
      */

      this.setState({
        loading: false
      });
    }
  };

  showWarningMessageToast(verifyAPIWarning) {
    return Object.keys(verifyAPIWarning)
      .filter((heading) => heading !== "warning" && heading !== "error")
      .map((heading, idx) => ({
        id: idx,
        severity: "warn",
        summary: heading,
        detail: verifyAPIWarning[heading],
        sticky: true,
        closable: false
      }));
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    if (userSelectedLanguage === "sw") {
      localeLang = "sv";
    } else if (userSelectedLanguage === "en") {
      localeLang = "en";
    }

    setupLocales(localeLang);

    userSessionAuthKeyReturnValue = setUserSessionAuthKey();
    const { sideBarReducer, payment } = this.props;

    // base64 = localStorage.getItem("pdfBase64");

    let localData = localStorage.getItem("rebelSkoolUser");
    let localObject = localData && JSON.parse(localData);
    this.setState({ repEmailId: localObject.emailID });

    if (
      localObject.userGUID !== undefined ||
      localObject.userGUID !== null ||
      localObject.userGUID.length > 0
    ) {
      this.setState({
        goToMyDashboardLink: localObject.userGUID + "/mainDashboard"
      });
    }

    this.setState({
      showNotification: false
    });
    window.scrollTo(0, 0);
    let splittedUrl = window.location.href.split("/");
    currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];
    window.scrollTo(0, 0);

    if (userSessionAuthKeyReturnValue) {
      this.getAnnualReportSetup();
      axios
        .get(
          "/annualReport/getHeader?reportId=" + currentReportGUIDFromUrl,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data) {
            let responseDate = response.data;
            let paymentEntryNo = response.data.paymentEntryNo;
            if (paymentEntryNo === 0 || paymentEntryNo === null) {
              this.setState({ paymentPending: true });
            } else {
              this.setState({ paymentPending: false });
            }
            this.setState({
              headerResponse: responseDate,
              sentToBolagsverketCount: responseDate.sendToBolagsverketCount
            });

            if (responseDate !== "") {
              let reportAccessReq = {
                reportId: responseDate.reportID
              };
              axios
                .post(
                  "/annualReport/getAccessStatus",
                  reportAccessReq,
                  userSessionAuthKeyReturnValue
                )
                .then((response) => {
                  switch (response.data) {
                    case 2:
                      linkSharedUser = 2; //Write
                      break;
                    case 3:
                      linkSharedUser = 3; //Read Only
                      break;
                    case 4:
                      linkSharedUser = 4; //No Access
                      break;
                    default:
                      linkSharedUser = 0;
                      break;
                  }

                  this.setState({
                    accessLevel: linkSharedUser
                  });

                  if (response.data <= 3) {
                    // axios
                    //   .get(
                    //     "/annualReport/pdf?reportGUID=" +
                    //     currentReportGUIDFromUrl,
                    //     {
                    //       responseType: "blob",
                    //     }
                    //   )
                    //   .then((response) => {
                    //     const url = window.URL.createObjectURL(
                    //       new Blob([response.data], { type: "application/pdf" })
                    //     );
                    //     this.setState({
                    //       pdfUrl: url,
                    //       isLoading: false
                    //     });
                    //   });

                    // let pp = previewPdfOnSamePage(currentReportGUIDFromUrl);

                    const runPreview = async () => {
                      const pp = await previewPdfOnSamePage(
                        currentReportGUIDFromUrl
                      );

                      this.setState({
                        pdfUrl: pp,
                        isLoading: false
                      });
                    };

                    runPreview();
                  }

                  axios
                    .get(
                      "/annualReportRepresentative/getByReportId?reportID=" +
                        responseDate.reportID,
                      userSessionAuthKeyReturnValue
                    )
                    .then((response) => {
                      if (response.data.length > 0) {
                        this.setState({ getRepList: response.data });
                        let repResponse = response.data;
                        let combinedKeys = [];
                        let ssnOptions = [];
                        repResponse &&
                          repResponse.forEach((val) => {
                            let mergedSet = {
                              no: val.no,
                              name: val.firstName + " " + val.lastName,
                              firstName: val.firstName,
                              lastName: val.lastName,
                              ssn: val.ssn,
                              designation: val.role
                            };

                            if (mergedSet.ssn !== "")
                              combinedKeys.push(mergedSet);

                            let ssnObj = {
                              name: val.ssn,
                              code: val.ssn
                            };

                            if (val.ssn !== "") ssnOptions.push(ssnObj);
                          });
                        if (combinedKeys && combinedKeys.length > 0) {
                          this.setState({ repValue: combinedKeys[0] });
                          if (combinedKeys[0].ssn !== undefined) {
                            this.setState({ repSSN: combinedKeys[0].ssn });
                          }
                        }
                        this.setState({ repOptions: combinedKeys });
                        this.setState({ ssnOptions: ssnOptions });

                        selectedSSNResult = combinedKeys[0];

                        this.setState({
                          firstName: selectedSSNResult.firstName,
                          lastName: selectedSSNResult.lastName,
                          designation: selectedSSNResult.designation
                        });

                        if (ssnOptions && ssnOptions.length > 0) {
                          if (ssnOptions[0].name !== undefined) {
                            this.setState({ ssn: ssnOptions[0] });
                          }
                        }
                      }
                    });
                  axios
                    .get(
                      "/annualReport/getCompletedPages?reportId=" +
                        responseDate.reportID,
                      userSessionAuthKeyReturnValue
                    )
                    .then((completedStatementTypesResponse) => {
                      sideBarReducer.values =
                        completedStatementTypesResponse.data;
                      sideBarGreenTickPages =
                        completedStatementTypesResponse.data;
                      sideBarGreenTickPages.push(
                        "My Dashboard",
                        "Company Information",
                        "Signature",
                        "Review And Send"
                      );
                      sideBarGreenTickPages = [
                        ...new Set(sideBarGreenTickPages)
                      ];

                      let updatePossibleNavigationPagesListString =
                        JSON.stringify(sideBarGreenTickPages);
                      localStorage.setItem(
                        "possibleAccessablePages",
                        updatePossibleNavigationPagesListString
                      );
                      this.setState({
                        reRender: true
                      });
                    });
                })
                .catch((error) => {
                  this.setState({
                    accessLevel: error.response.data
                  });
                });
            }
            // }

            axios
              .get(
                "/annualReport/getCompletedPages?reportId=" +
                  response.data.reportID,
                userSessionAuthKeyReturnValue
              )
              .then((completedStatementTypesResponse) => {
                let sideBarReducerValues = [];
                sideBarReducerValues = completedStatementTypesResponse.data;
                if (linkSharedUser !== 3) {
                  sideBarReducerValues.push("Payment");
                }
                sideBarReducer.values = sideBarReducerValues;
                sideBarGreenTickPages = completedStatementTypesResponse.data;
                this.setState({
                  reRender: true
                });

                setTimeout(() => {
                  if (payment.values.checkoutRef !== "") {
                    axios
                      .get(
                        "/annualReportPackage/getCheckoutDetailsByRef?checkoutRef=" +
                          payment.values.checkoutRef,
                        userSessionAuthKeyReturnValue
                      )
                      .then((checkoutRefResponse) => {
                        this.setState({
                          loading: false
                        });
                        if (
                          checkoutRefResponse.data !== "" &&
                          !checkoutRefResponse.data.isNotificationShown
                        ) {
                          this.setState({
                            showNotification: true
                          });
                          axios
                            .get(
                              "/annualReportPackage/updateNotificationByCheckoutRef?checkoutRef=" +
                                payment.values.checkoutRef,
                              userSessionAuthKeyReturnValue
                            )
                            .then((updateNotifyResponse) => {});
                        }
                      });
                    // this.setState({ isLoading: false });
                  } else {
                    this.setState({
                      loading: false
                    });
                  }
                }, 3000);
              });
          }
        });
    }

    tourGuidePages = localStorage.getItem("tourGuidePages");
    if (tourGuidePages != null) {
      tourGuidePages = JSON.parse(tourGuidePages);
      if (!tourGuidePages.includes(currentPageTourGuideName)) {
        tourGuidePages.push(currentPageTourGuideName);
      }
      localStorage.setItem("tourGuidePages", JSON.stringify(tourGuidePages));
    } else {
      let currentPageTourGuideArray = [];
      currentPageTourGuideArray.push(currentPageTourGuideName);
      localStorage.setItem(
        "tourGuidePages",
        JSON.stringify(currentPageTourGuideArray)
      );
    }
  }

  ssnOnChange(e) {
    const { repOptions } = this.state;

    let userInput = e.value;
    let name = e.value.name;

    if (userInput.length > 8) {
      let formatted = userInput;
      if (!userInput.includes("-"))
        formatted = userInput.slice(0, 8) + "-" + userInput.slice(8);
      this.setState({
        ssn: formatted
      });

      if (formatted.length === 13) {
        name = formatted;
      }
    } else
      this.setState({
        ssn: userInput
      });

    selectedSSNResult = repOptions.filter((val) => val.ssn === name)[0];

    if (selectedSSNResult !== undefined) {
      this.setState({
        firstName: selectedSSNResult.firstName,
        lastName: selectedSSNResult.lastName,
        designation: selectedSSNResult.designation
      });
    } else {
      this.setState({
        firstName: "",
        lastName: "",
        designation: ""
      });
    }
  }

  repValueOnChange(e) {
    const { getRepList } = this.state;
    this.setState({ repValue: e.target.value });
    let selectedValue = e.target.value;
    if (selectedValue !== "" && selectedValue !== null) {
      //Find repFirstName in repList
      let FilteredRep =
        getRepList && getRepList.filter((val) => val.no === selectedValue.no);

      this.setState({ repSSN: FilteredRep[0].ssn });
    }
  }

  paymentSuccessModalOnHide() {
    this.setState({
      showPayementSuccessModal: false
    });
  }

  acceptSendToBolagsverket() {
    this.toast.show({
      severity: "success",
      summary: TranslationFile.SumissionSuccess[userSelectedLanguage],
      detail: TranslationFile.PaymentSubmitToBolags[userSelectedLanguage],
      life: 2000
    });
  }

  next(e) {
    const annualReport = "/annualreport/";
    this.props.history.push(
      annualReport + currentReportGUIDFromUrl + "/reviewAndSend"
    );
  }

  editReport() {
    const annualReport = "/annualreport/";
    this.props.history.push(
      annualReport + currentReportGUIDFromUrl + "/companyInfo"
    );
    window.location.reload(false);
  }

  sideBarCallback = (value) => {};
  sideBarStatus = (e) => {
    this.setState({
      sideBarStatus: e
    });
  };

  redirectToIncomeDeclaration2() {
    window.open(
      config.SRU.url + "/" + currentReportGUIDFromUrl + "/companyInfo",
      "_blank"
    );
  }

  UploadLegendTemplate() {
    return (
      <div className="review-legend-template">
        {" "}
        {TranslationFile.uploadToBlogsText[userSelectedLanguage]}
      </div>
    );
  }
  reviewLegendTemplate() {
    return (
      <div className="review-legend-template">
        {TranslationFile.ReviewPDFText[userSelectedLanguage]}
      </div>
    );
  }

  componentDidMount() {
    if (this.state.run) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    // this.startTimer();
    let userTourGuide = JSON.parse(localStorage.getItem("TourGuide")) || false;

    if (userTourGuide) {
      if (
        tourGuidePages != null &&
        tourGuidePages.length > 0 &&
        tourGuidePages.includes(currentPageTourGuideName)
      ) {
        setTimeout(() => {
          this.setState({ run: false });
        }, 200);
      } else {
        setTimeout(() => {
          this.setState({ run: true });
        }, 200);
      }
    }

    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !prevState.sentToBolagsverketDialogBox &&
      this.state.sentToBolagsverketDialogBox
    ) {
      this.startSentToBolagsverketCarousel();
    }

    if (
      prevState.sentToBolagsverketDialogBox &&
      !this.state.sentToBolagsverketDialogBox
    ) {
      this.stopSentToBolagsverketCarousel();
    }
  }

  componentWillUnmount() {
    this.stopSentToBolagsverketCarousel();
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
  }

  loadData = async () => {
    const result = await this.getAnnualReportSetup();

    this.setState({
      showSkatterverketButton: result
    });
  };

  tourStatus = (e) => {
    this.setState({ run: e });
  };

  submitToBolagserketAPI = (checkWarning) => {
    const { headerResponse } = this.state;

    let bolagsverketSubmitObj = {
      pnr: headerResponse.witnessSsn.replace("-", ""),
      orgnr: headerResponse.registrationNo.replace("-", ""),
      reportGuid: headerResponse.reportGUID,
      checkWarning: checkWarning
    };

    // Start dynamic progress
    this.progressInterval = setInterval(() => {
      this.setState((prevState) => {
        const newVal = Math.min(
          prevState.progressValue + Math.floor(Math.random() * 10) + 15,
          95
        );
        return { progressValue: newVal };
      });
    }, 1000);

    this.setState({
      showConfirmReSubmitDialogBox: false,
      bolagsverketApiBtnClicked: true
    });

    axios
      .post(
        "/xhtml/submitToBolagsverket",
        bolagsverketSubmitObj,
        userSessionAuthKeyReturnValue
      )
      .then((response) => {
        if (response.data) {
          clearInterval(this.progressInterval);
          this.setState({
            bolagsverketApiResponse: response.data,
            bolagsverketApiLoading: false,
            bolagsverketApiBtnClicked: false,
            progressValue: 100,
            bolagsverketApiStatus: true,
            sentToBolagsverketDialogBox: true,
            sentToBolagsverketCarouselPage: 0,
            goToBolagsverketLink: response.data.submissionResult.url
          });
          // this.startTimer(); // start when component mounts
        }
      })
      .catch((error) => {
        clearInterval(this.progressInterval);

        let errorMsg = error.response.data.error;

        if (errorMsg === "reachedMaxSubmission") {
          this.setState({ bolagsverketSubmitLimitReachedDialog: true });
        }

        if (errorMsg === "AnnualReportVerifyApiWarning") {
          // this.setState({
          //   bolagsverketWarningDialog: true,
          //   verifyAPIWarning: error.response.data
          // });

          this.setState(
            {
              bolagsverketWarningDialog: true,
              verifyAPIWarning: error.response.data
            },
            () => {
              if (this.msgs.current) {
                this.msgs.current.clear();
                this.msgs.current.show(
                  this.showWarningMessageToast(error.response.data)
                );
              }
            }
          );
        }
        this.setState({
          bolagsverketApiLoading: false,
          bolagsverketApiBtnClicked: false,
          progressValue: 0,
          bolagsverketApiResponse:
            errorMsg === "reachedMaxSubmission" ||
            errorMsg === "AnnualReportVerifyApiWarning"
              ? ""
              : errorMsg,
          bolagsverketApiStatus: false,
          //TODO: set sentToBolagsverketDialogBox to false, before push
          sentToBolagsverketDialogBox: false,
          goToBolagsverketLink: ""
        });
      });
  };

  submitToBolagserket = (checkWarning) => {
    const {
      ssn,
      firstName,
      lastName,
      designation,
      repEmailId,
      headerResponse
    } = this.state;

    if (
      ssn == undefined ||
      firstName.length == 0 ||
      lastName.length == 0 ||
      designation.length == 0 ||
      repEmailId.length == 0
    ) {
      this.toast.show({
        severity: "error",
        // summary: TranslationFile.SumissionSuccess[userSelectedLanguage],
        detail: TranslationFile.FillMandatryFields[userSelectedLanguage],
        life: 2000
      });
    } else {
      this.setState({
        bolagsverketApiLoading: true,
        bolagsverketApiBtnClicked: true,
        progressValue: 0
      });

      if (headerResponse.sendToBolagsverketCount > 0 && checkWarning) {
        this.setState({
          showConfirmReSubmitDialogBox: true,
          bolagsverketApiBtnClicked: false
        });
      } else {
        this.setState({
          showConfirmReSubmitDialogBox: false,
          bolagsverketApiBtnClicked: true
        });

        this.submitToBolagserketAPI(checkWarning);
      }
    }
  };

  confirmReSubmitFooterContent = () => {
    return (
      <div>
        <Button
          label="No"
          icon="pi pi-times"
          onClick={() => this.setState({ showConfirmReSubmitDialogBox: false })}
          className="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          onClick={() => this.submitToBolagserketAPI(true)}
          autoFocus
        />
      </div>
    );
  };

  renderJSON = (data) => {
    if (typeof data === "object" && data !== null) {
      if (Array.isArray(data)) {
        return (
          <ul>
            {data.map((item, index) => (
              <li key={index}>{this.renderJSON(item)}</li>
            ))}
          </ul>
        );
      } else {
        return (
          <ul>
            {Object.entries(data).map(([key, value]) => (
              <li key={key}>
                <strong>{key}:</strong> {this.renderJSON(value)}
              </li>
            ))}
          </ul>
        );
      }
    }
    return <span>{String(data)}</span>;
  };

  callback = (annualReport, session, link, status) => {
    let sessionFromLS = localStorage.getItem("sessionUUID");
    if (status) {
      this.props.history.push(annualReport + sessionFromLS + link);
    }
    this.setState({
      reRender: true
    });
  };

  correctTheAnnualReport() {
    const { headerResponse, verifyAPIWarning } = this.state;
    this.setState({ bolagsverketWarningDialog: false });

    if (verifyAPIWarning.hasOwnProperty("customMessage")) {
      axios
        .get(
          "/annualReport/updateAllowEdit/" + headerResponse.reportID,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {});
    }
  }

  productTemplate = (item) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "300px",
          width: "100%",
          overflow: "hidden"
        }}
      >
        <img
          src={item.src}
          alt="carousel"
          style={{
            maxWidth: item.zoom ? "140%" : "100%",
            maxHeight: item.zoom ? "140%" : "100%",
            objectFit: "contain",
            transition: "0.3s ease"
          }}
        />
      </div>
    );
  };

  render() {
    const {
      showNotification,
      pdfUrl,
      isLoading,
      repValue,
      repSSN,
      repEmailId,
      repDate,
      termsCheck,
      bolagsverketApiLoading,
      bolagsverketApiResponse,
      bolagsverketApiBtnClicked,
      bolagsverketApiStatus,
      sentToBolagsverketDialogBox,
      sentToBolagsverketCarouselPage,
      goToMyDashboardLink,
      goToBolagsverketLink,
      headerResponse,
      showConfirmReSubmitDialogBox,
      accessLevel,
      showSkatterverketButton,
      verifyAPIWarning
    } = this.state;
    return (
      <div className="annual-notes-main-div" style={{ overflow: "hidden" }}>
        {accessLevel === 4 ? (
          <NoAccess />
        ) : (
          <>
            <Joyride
              continuous
              run={this.state.run}
              disableBeacon={true}
              showProgress={false}
              showSkipButton
              steps={steps}
              scrollToFirstStep
              scrollToSteps={true}
              disableScrolling={false}
              scrollOffset={100}
              locale={{
                last: "End",
                back: "Back",
                next: "Next",
                skip: "Skip"
              }}
              styles={{
                options: {
                  zIndex: 10000
                }
              }}
            />

            <Toast
              ref={(el) => {
                this.toast = el;
              }}
              style={{ marginTop: "80px" }}
            ></Toast>

            {/* <Header /> */}
            <NavBarHeader
              callBack={this.callback}
              isAppPortal={true}
              isHomePage={false}
            />

            <div className="paymentSideBar">
              <Sidebar
                children="Review And Send"
                sideBarStatus={this.sideBarStatus.bind(this)}
                sideBarCallback={(e) => this.sideBarCallback(e)}
                tourStatus={this.tourStatus.bind(this)}
              />
            </div>
            <ConfirmPopup />
            {isLoading ? (
              <div className="ISLoading">
                <i
                  className="pi pi-spin pi-spinner"
                  style={{ fontSize: "2rem" }}
                ></i>
              </div>
            ) : (
              <div>
                <div
                  className="reviewAndSendPaymentSuccess"
                  style={{ display: showNotification ? "inherit" : "none" }}
                ></div>

                <div
                  className={
                    this.state.sideBarStatus
                      ? "reviewAndSend-div"
                      : "reviewAndSend-div-sidebar"
                  }
                >
                  <Fieldset
                    legend={this.reviewLegendTemplate()}
                    className="review-fieldset"
                  >
                    <div
                      className={
                        this.state.sideBarStatus
                          ? "review-edit review-edit-open"
                          : "review-edit review-edit-sidebar"
                      }
                    >
                      <Button
                        label={
                          TranslationFile.EditReportText[userSelectedLanguage]
                        }
                        icon="pi pi-pencil"
                        onClick={() => this.editReport()}
                        disabled={linkSharedUser === 3}
                      />
                    </div>
                    <div>
                      <center>
                        <div
                          className="review-iframe-div"
                          onContextMenu={(e) => e.preventDefault()}
                        >
                          <RBBLiframe
                            className={
                              this.state.sideBarStatus
                                ? "review-iframe review-iframe-open"
                                : "review-iframe review-iframe-sidebar"
                            }
                            reportGuid={currentReportGUIDFromUrl}
                          />
                        </div>
                      </center>
                    </div>
                  </Fieldset>
                </div>
              </div>
            )}

            {linkSharedUser !== 3 && (
              <div
                className={
                  this.state.sideBarStatus
                    ? "reviewAndSend-div"
                    : "reviewAndSend-div-sidebar"
                }
                style={{ marginTop: "0px" }}
              >
                <center>
                  <div className="review-terms-condition">
                    <Checkbox
                      checked={termsCheck}
                      className={
                        this.state.showAlert
                          ? "p-invalid p-invalid-glow-checkbox"
                          : ""
                      }
                      onChange={(e) => {
                        if (!this.state.paymentPending) {
                          this.setState({
                            termsCheck: e.checked,
                            showAlert: false
                          });
                        } else {
                          this.setState({ showAlert: true });
                          this.toast.show({
                            severity: "warn",
                            summary:
                              TranslationFile.paymentError[
                                userSelectedLanguage
                              ],
                            detail:
                              TranslationFile.PaymentRequiredToAcceptTerms[
                                userSelectedLanguage
                              ],
                            life: 6000
                          });
                        }
                      }}
                    />
                    <span style={{ marginLeft: "1%" }}>
                      {TranslationFile.ReviewAcceptText[userSelectedLanguage]}
                    </span>
                    <span>
                      <a
                        className="classcolourterm"
                        href={config.corporatePage.url + "terms-of-usage"}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {TranslationFile.loginTermsText[userSelectedLanguage]}
                      </a>
                    </span>
                  </div>
                  <div className="review-submit">
                    {headerResponse.sendToBolagsverketCount > 0 && (
                      <div>
                        <p>
                          <i
                            className="pi pi-exclamation-circle"
                            id="reportAlreadySubmittedExclamationIcon"
                          ></i>
                          {
                            TranslationFile.reportAlreadySubmitted[
                              userSelectedLanguage
                            ]
                          }
                          {"  "}
                          <b>
                            {moment(
                              headerResponse.sentBolagsverketDateTimeString
                            ).format("YYYY-MM-DD HH:mm:ss.SS")}
                          </b>
                        </p>
                      </div>
                    )}

                    <div>
                      {repValue !== "" &&
                      repValue !== null &&
                      repSSN !== "" &&
                      repSSN !== null &&
                      repEmailId !== "" &&
                      repEmailId !== null &&
                      repDate !== "" &&
                      repDate !== null &&
                      termsCheck ? (
                        <Button
                          label={
                            headerResponse.sendToBolagsverketCount > 0
                              ? TranslationFile.reSubmit[userSelectedLanguage]
                              : TranslationFile.uploadToBlogsText[
                                  userSelectedLanguage
                                ]
                          }
                          icon="pi pi-send"
                          disabled={linkSharedUser === 3}
                          onClick={() => this.submitToBolagserket(true)}
                        />
                      ) : (
                        <Button
                          label={
                            headerResponse.sendToBolagsverketCount > 0
                              ? TranslationFile.reSubmit[userSelectedLanguage]
                              : TranslationFile.uploadToBlogsText[
                                  userSelectedLanguage
                                ]
                          }
                          icon="pi pi-send"
                          disabled={true}
                          onClick={() => this.submitToBolagserket(true)}
                        />
                      )}
                    </div>

                    <div>
                      {bolagsverketApiBtnClicked === true &&
                      bolagsverketApiLoading === true ? (
                        <div style={{ marginTop: "4em", marginBottom: "4em" }}>
                          {
                            TranslationFile.SubmittingAnnualReport[
                              userSelectedLanguage
                            ]
                          }
                          <ProgressBar
                            value={this.state.progressValue}
                            className="sendingToBolagsverketProgressBar"
                          />
                        </div>
                      ) : bolagsverketApiResponse !== "" &&
                        bolagsverketApiStatus ? (
                        <>
                          <Dialog
                            visible={sentToBolagsverketDialogBox}
                            style={{ width: "50vw" }}
                            onHide={() => {
                              if (!sentToBolagsverketDialogBox) return;
                              this.stopSentToBolagsverketCarousel();
                              this.setState({
                                sentToBolagsverketDialogBox: false
                              });
                              window.location.reload(false);
                            }}
                            className="sentToBolagsverketDialogBox"
                          >
                            <div>
                              <center>
                                <Carousel
                                  value={Carouselitems}
                                  numVisible={1}
                                  numScroll={1}
                                  circular
                                  page={sentToBolagsverketCarouselPage}
                                  showNavigators={false}
                                  showIndicators={false}
                                  itemTemplate={(e) => this.productTemplate(e)}
                                  className="sentToBolagsverketCarousel"
                                />
                                <br />
                                <p className="m-0">
                                  {
                                    TranslationFile.SentToBolagsSuccesssfully[
                                      userSelectedLanguage
                                    ]
                                  }
                                </p>
                                <br />
                                <div className="sentToBolagsverketDialogBoxBtn">
                                  <div>
                                    <Button
                                      severity="success"
                                      onClick={() => {
                                        window.open(
                                          goToBolagsverketLink,
                                          "_blank"
                                        );
                                      }}
                                    >
                                      {
                                        TranslationFile.GoToMyBolagsverket[
                                          userSelectedLanguage
                                        ]
                                      }
                                    </Button>

                                    <React.Fragment>
                                      <CopyToClipboard
                                        text={goToBolagsverketLink}
                                      >
                                        <p className="sentToBolagsverketDialogBoxCopyLinkBtn">
                                          <i
                                            className="pi pi-copy"
                                            id="sentToBolagsverketDialogBoxCopyLinkIcon"
                                          ></i>

                                          {
                                            TranslationFile
                                              .dashboardCopyLinkBtn[
                                              userSelectedLanguage
                                            ]
                                          }
                                        </p>
                                      </CopyToClipboard>
                                    </React.Fragment>
                                  </div>
                                  <div>
                                    <Button
                                      severity="info"
                                      onClick={() => {
                                        window.location.assign(
                                          "/" + goToMyDashboardLink
                                        );
                                      }}
                                    >
                                      {
                                        TranslationFile.GoToDashboard[
                                          userSelectedLanguage
                                        ]
                                      }
                                    </Button>

                                    <React.Fragment>
                                      <CopyToClipboard
                                        text={
                                          window.location.origin +
                                          "/" +
                                          goToMyDashboardLink
                                        }
                                      >
                                        <p className="sentToBolagsverketDialogBoxCopyLinkBtn">
                                          <i
                                            className="pi pi-copy"
                                            id="sentToBolagsverketDialogBoxCopyLinkIcon"
                                          ></i>

                                          {
                                            TranslationFile
                                              .dashboardCopyLinkBtn[
                                              userSelectedLanguage
                                            ]
                                          }
                                        </p>
                                      </CopyToClipboard>
                                    </React.Fragment>
                                  </div>
                                </div>
                              </center>
                            </div>
                          </Dialog>
                        </>
                      ) : (
                        // bolagsverketApiResponse == "error" && (
                        !bolagsverketApiStatus &&
                        bolagsverketApiResponse.length > 0 && (
                          <center>
                            <div
                              style={{
                                textAlign: "center",
                                marginTop: "1rem",
                                color: "#d32f2f"
                              }}
                            >
                              <i
                                className="pi pi-times-circle"
                                style={{
                                  fontSize: "1.5rem",
                                  marginRight: "0.5rem",
                                  verticalAlign: "middle"
                                }}
                              ></i>
                              <span
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "500",
                                  verticalAlign: "middle"
                                }}
                              >
                                {/* Error: Please ensure the witness SSN is valid. */}
                                {bolagsverketApiResponse}
                              </span>
                            </div>
                          </center>
                        )
                      )}
                    </div>

                    <div>
                      <Dialog
                        visible={this.state.processingDialog}
                        closable={false}
                        dismissableMask={false}
                        modal
                        showHeader={false}
                        style={{ width: "24rem" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            padding: "2rem",
                            textAlign: "center"
                          }}
                        >
                          <ProgressSpinner
                            style={{
                              width: "70px",
                              height: "70px"
                            }}
                            strokeWidth="4"
                          />

                          <div
                            style={{
                              marginTop: "1.5rem",
                              fontSize: "16px"
                            }}
                          >
                            {this.state.processingMessage}
                          </div>
                        </div>
                      </Dialog>

                      {showSkatterverketButton && (
                        <div>
                          <hr className="hrBwtnSubmitBtnAndGoToIncomeDeclaration2Btn" />
                          <b>
                            {" "}
                            {
                              TranslationFile
                                .reviewAndDownloadIncomeDeclaration2Files[
                                userSelectedLanguage
                              ]
                            }
                          </b>
                          <br />
                          {repValue &&
                          repSSN &&
                          repEmailId &&
                          repDate &&
                          termsCheck ? (
                            <Button
                              label={
                                TranslationFile.goToIncomeDeclaration2Text[
                                  userSelectedLanguage
                                ]
                              }
                              icon="pi pi-send"
                              disabled={
                                linkSharedUser === 3 || this.state.loading
                              }
                              onClick={() => this.goToSRUPortal()}
                              className="submitToBolagsverketBtn button-wrapper"
                              style={{
                                marginBottom: "12px",
                                marginTop: "12px"
                              }}
                            />
                          ) : (
                            <Button
                              label={
                                TranslationFile.goToIncomeDeclaration2Text[
                                  userSelectedLanguage
                                ]
                              }
                              icon="pi pi-send"
                              disabled={true}
                              onClick={() => this.goToSRUPortal()}
                              style={{
                                marginBottom: "12px",
                                background: "#FF7A00",
                                marginTop: "12px"
                              }}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </center>
              </div>
            )}

            <Dialog
              visible={this.state.bolagsverketSubmitLimitReachedDialog}
              style={{ width: "32rem" }}
              breakpoints={{ "960px": "75vw", "641px": "90vw" }}
              blockScroll
              modal
              onHide={() => {
                this.setState({ bolagsverketSubmitLimitReachedDialog: false });
                window.location.reload(false);
              }}
            >
              <center>
                <i
                  className="pi pi-exclamation-triangle"
                  style={{
                    fontSize: "3rem",
                    color: "#ff5f00",
                    marginBottom: "12px"
                  }}
                ></i>
              </center>
              <p>
                {
                  TranslationFile.submitToBolagsverketLimitReached[
                    userSelectedLanguage
                  ]
                }
              </p>

              <p>
                <i style={{ fontSize: "12px" }}>
                  {TranslationFile.forMoreAssistance[userSelectedLanguage]}
                  <a href="mailto:info@rebelskool.com">info@rebelskool.com</a>
                </i>
              </p>
            </Dialog>

            {/* //Bolagsverket Verify Get warning */}
            <Dialog
              visible={this.state.bolagsverketWarningDialog}
              breakpoints={{ "960px": "75vw", "641px": "90vw" }}
              blockScroll
              modal
              onHide={() => {
                this.setState({ bolagsverketWarningDialog: false });
              }}
              closable={false}
            >
              <div style={{ marginBottom: "20px", display: "flex" }}>
                <i
                  className="pi pi-exclamation-triangle"
                  style={{
                    fontSize: "2rem",
                    color: "#ff5f00"
                  }}
                ></i>
                <b
                  style={{
                    marginTop: "4px",
                    marginLeft: "45px",
                    position: "absolute"
                  }}
                >
                  {
                    TranslationFile.warningsFromBolagsverket[
                      userSelectedLanguage
                    ]
                  }
                </b>
              </div>

              {Object.keys(verifyAPIWarning)
                .filter(
                  (heading) => heading !== "warning" && heading !== "error"
                )
                .map(
                  (heading, idx) =>
                    heading !== "customMessage" && (
                      <>
                        <div key={idx} className="bolagsverketWarningListDiv">
                          <div>{verifyAPIWarning[heading]}</div>
                        </div>
                      </>
                    )
                )}

              <div className="bolagsverketSubmitWithWarningLbl">
                <center>
                  <i
                    className="pi pi-info-circle"
                    id="bolagsverketCaseOfficerLblIcon"
                  ></i>
                  <b>
                    {
                      TranslationFile.bolagsverketSubmitWithWarning[
                        userSelectedLanguage
                      ]
                    }
                  </b>
                </center>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%"
                }}
              >
                <Button
                  // label="Primary"
                  raised
                  className="correctTheAnnualReportBtn"
                  label={
                    TranslationFile.correctTheAnnualReport[userSelectedLanguage]
                  }
                  onClick={() => {
                    this.correctTheAnnualReport();
                  }}
                />

                <button
                  className="submitToBolagsWithWarningBtn"
                  onClick={() => {
                    this.setState({ bolagsverketWarningDialog: false });
                    this.submitToBolagserket(false);
                  }}
                >
                  {TranslationFile.submitWithWarnings[userSelectedLanguage]}
                  <svg
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    className="submitToBolagsWithWarningIcon"
                  >
                    <path
                      clip-rule="evenodd"
                      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                      fill-rule="evenodd"
                    ></path>
                  </svg>
                </button>
              </div>
            </Dialog>

            <ConfirmDialog
              group="declarative"
              visible={showConfirmReSubmitDialogBox}
              onHide={() => {
                if (!showConfirmReSubmitDialogBox) return;
                this.setState({ showConfirmReSubmitDialogBox: false });
              }}
              message={
                TranslationFile.reSubmitConfirmation[userSelectedLanguage]
              }
              header={TranslationFile.confirmation[userSelectedLanguage]}
              icon="pi pi-exclamation-triangle"
              accept={() => this.submitToBolagserketAPI(true)}
              reject={() => {
                this.setState({ showConfirmReSubmitDialogBox: false });
              }}
            />
            <ScrolltoTop />
            <FooterContactTab
              sideBar={this.state.sideBarStatus}
              isCorpPortal={false}
              isHomePage={true}
            />
          </>
        )}
      </div>
    );
  }
}
export default connect(mapStateToProps, null)(ReviewAndSend);
